import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import TextLink from '../common/TextLink';
import CameraDisabledIcon from '../common/Icons/CameraDisabled';
import Messages from '../../config/messages.constants';
import { useTwilioUserMediaContext } from '../../customer-call-sdk';

const StyledNoVideoView = styled.div`
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.14);
    border-radius: 0.625rem;

    .camera-disabled-icon {
        min-width: 300px;
        min-height: 300px;
        width: calc(100vh * 0.3);
        height: calc(100vh * 0.3);
        color: rgba(255, 255, 255, 0.1);
    }
`;

export interface NoVideoViewProps extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * No Video View Container component
 */
const NoVideoView: React.FC<NoVideoViewProps> = ({ className }) => {
    const { mediaError, isVideoBlocked, isRequestingVideoPermission } = useTwilioUserMediaContext();

    const getCameraBlockedMessage = (): string => {
        return Messages.CAMERA_MICROPHONE_BLOCKED;
    };

    const renderError = (error: any) => {
        let errorMessage = '';
        switch (error.name) {
            case 'NotReadableError':
                errorMessage = Messages.CAMERA_MICROPHONE_USED_BY_OTHER_APP;
                break;
            case 'NotAllowedError':
                errorMessage = getCameraBlockedMessage();
                break;
            case 'NotFoundError':
            default:
                errorMessage = Messages.CAMERA_NOT_CONNECTED;
                break;
        }
        return (
            <>
                <div
                    data-testid="camera-block-message"
                    className="text-xl error text-center mb-12"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: errorMessage }}
                />
            </>
        );
    };
    return (
        <StyledNoVideoView
            className={cx('w-full h-full flex flex-col justify-center items-center', className, {
                'justify-center': isRequestingVideoPermission,
            })}
        >
            <div className="flex justify-center mt-16">
                <CameraDisabledIcon
                    data-testid="camera-disabled-icon"
                    id="camera-disabled-icon"
                    className="camera-disabled-icon"
                />
            </div>
            {!isRequestingVideoPermission && (
                <>
                    {isVideoBlocked && mediaError && renderError(mediaError)}

                    {false && (
                        <TextLink
                            className="text-center mb-20"
                            data-testid="need-help-link"
                            href={`${process.env.REACT_APP_CAMERA_MICROPHONE_HELP_LINK}`}
                            target="new"
                            rel="noopener noreferrer"
                        >
                            Need help?
                        </TextLink>
                    )}
                </>
            )}
        </StyledNoVideoView>
    );
};

export default NoVideoView;
